/**
 * Task statuses
 */
exports.statuses = {
  queued: { class: 'info' },
  processing: { class: 'primary' },
  completed: { class: 'success' },
  failed: { class: 'danger' },
}
